import { useAppI18N } from '@/app'
import { Button } from '@/components'
import { analytics } from '@/services/analytics/segment'
import { AnyFunction } from '@codeleap/types'

export function ShareProgressButton({ onShare }: { onShare: AnyFunction }) {
  const { t } = useAppI18N()

  const shareProgress = () => {
    analytics.track('lesson_progress_share')
    onShare?.()
  }

  return (
    <Button
      variants={['fullWidth', 'outline']}
      text={t('learn.components.doneModal.shareButton')}
      debugName={`Modal done share button`}
      onPress={shareProgress}
    />
  )
}
